import type { AuditChange, AuditLogRow } from '../../api/frontDeskUsers';

/** Human names for the columns the history can show (name, last name, photo and phone). */
const FIELD_LABEL: Record<string, string> = {
  name: 'First name',
  last_name: 'Last name',
  photo_url: 'Photo',
  tel: 'Phone',
  pending_tel: 'Pending phone',
};

const show = (v: unknown): string => (v === null || v === undefined || v === '' ? 'empty' : String(v));

/** «Last name: Diaz → Diaz Perez». The photo is a storage key, so only the fact that it changed is said. */
export const describeChange = (c: AuditChange): string => {
  const label = FIELD_LABEL[c.field] ?? c.field;
  if (c.field === 'photo_url') return `${label} changed`;
  return `${label}: ${show(c.old)} → ${show(c.new)}`;
};

export interface ChangeLogEntry { id: string; when: string; who: string; lines: string[] }

/** The history as rows of «who, when, what», skipping a row with nothing to say. */
export const toChangeLog = (rows: AuditLogRow[]): ChangeLogEntry[] =>
  rows
    .filter((r) => Array.isArray(r.changes) && r.changes.length > 0)
    .map((r) => ({
      id: String(r.id),
      when: r.created_at,
      who: r.author_name?.trim() || 'Unknown',
      lines: r.changes.map(describeChange),
    }));
